export interface Resource {
  id: string;
  title: string;
  category: string;
  region: string;
  year: number;
  genres: string[];
  rating: number;
  views: number;
  publishDate: string;
  duration: string;
  director: string;
  cast: string[];
  synopsis: string;
  cover: string;
  banner?: string;
  featured?: boolean;
}

export interface CategoryMeta {
  slug: string;
  name: string;
  desc: string;
  intro: string;
  icon: string;
}

export const categoryMeta: CategoryMeta[] = [
  {
    slug: 'movie',
    name: '电影',
    desc: '院线佳作与经典国语影片',
    intro: '精选国产与华语电影，覆盖剧情、悬疑、动作、科幻等多种类型，带你重温大银幕上的经典与佳作。',
    icon: 'ri-film-line',
  },
  {
    slug: 'tv',
    name: '电视剧',
    desc: '热播与口碑国语剧集',
    intro: '汇集近年来热播与口碑兼具的国语电视剧集，涵盖古装、都市、悬疑、青春等题材，一集接一集看不停。',
    icon: 'ri-tv-2-line',
  },
  {
    slug: 'documentary',
    name: '纪录片',
    desc: '自然人文历史纪实',
    intro: '记录真实世界的纪录片集合，从自然生态到人文历史，用镜头带你看见更广阔的世界。',
    icon: 'ri-camera-lens-line',
  },
  {
    slug: 'variety',
    name: '综艺',
    desc: '轻松有趣的综艺节目',
    intro: '涵盖音乐、科普、美食等多种类型的国语综艺节目，轻松有趣，适合休闲时光观看。',
    icon: 'ri-mic-line',
  },
];

export const regionOptions: string[] = [
  '中国大陆',
  '中国香港',
  '中国台湾',
  '日本',
  '韩国',
  '欧美',
];

export const yearOptions: number[] = [2024, 2023, 2022, 2021, 2020];

export const genreOptions: string[] = [
  '剧情',
  '悬疑',
  '动作',
  '爱情',
  '喜剧',
  '科幻',
  '历史',
  '犯罪',
  '家庭',
  '青春',
  '自然',
  '人文',
];

export const resources: Resource[] = [
  {
    id: '1001',
    title: '长夜微光',
    category: 'movie',
    region: '中国大陆',
    year: 2024,
    genres: ['悬疑', '剧情'],
    rating: 8.7,
    views: 1286000,
    publishDate: '2024-09-12',
    duration: '128分钟',
    director: '陈以恒',
    cast: ['周凛', '苏晚棠', '林知遥'],
    synopsis:
      '一场持续七天的雨夜，让一座南方小城陷入重重迷雾。刑警周凛在追查一桩旧案时，发现所有线索都指向多年前被尘封的真相。当微光穿透长夜，他必须在良知与规则之间做出抉择。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20thriller%20film%20poster%20artwork%2C%20a%20lone%20figure%20standing%20under%20a%20dim%20streetlamp%20in%20a%20rain-soaked%20narrow%20alley%20at%20night%2C%20deep%20shadows%20and%20teal-blue%20cinematic%20color%20grading%20with%20a%20single%20warm%20amber%20light%2C%20moody%20atmospheric%20fog%2C%20dramatic%20film%20noir%20composition%2C%20professional%20movie%20key%20art%2C%20no%20text%2C%20highly%20detailed&width=600&height=900&seq=gy-movie-01&orientation=portrait',
    banner:
      'https://readdy.ai/api/search-image?query=Cinematic%20widescreen%20Chinese%20thriller%20film%20banner%20artwork%2C%20rain-soaked%20neon%20city%20alley%20at%20night%20with%20a%20lone%20silhouette%20under%20a%20streetlamp%2C%20deep%20teal%20shadows%20and%20warm%20amber%20accents%2C%20atmospheric%20fog%20and%20reflections%2C%20dramatic%20wide%20composition%20with%20empty%20space%20for%20text%2C%20no%20text%2C%20highly%20detailed&width=1600&height=900&seq=gy-banner-01&orientation=landscape',
    featured: true,
  },
  {
    id: '1002',
    title: '山海谣',
    category: 'movie',
    region: '中国大陆',
    year: 2023,
    genres: ['剧情', '历史'],
    rating: 8.4,
    views: 986000,
    publishDate: '2023-11-05',
    duration: '142分钟',
    director: '韩慕之',
    cast: ['陆怀山', '沈若溪', '郑云舟'],
    synopsis:
      '上世纪五十年代，一支测绘队深入西南群山，为修建公路勘探线路。年轻的技术员与当地村民在误解与磨合中建立起深厚情谊，用青春和汗水在山海之间写下动人的歌谣。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20historical%20drama%20film%20poster%20artwork%2C%20misty%20mountain%20ranges%20and%20rolling%20green%20hills%20at%20dawn%2C%20an%20ancient%20stone%20village%20with%20distant%20figures%20walking%20a%20winding%20path%2C%20soft%20warm%20golden%20sunrise%20light%2C%20painterly%20atmospheric%20composition%2C%20epic%20poetry%20mood%2C%20professional%20movie%20key%20art%2C%20no%20text%2C%20highly%20detailed%2C%20muted%20earthy%20tones&width=600&height=900&seq=gy-movie-02&orientation=portrait',
  },
  {
    id: '1003',
    title: '追风者',
    category: 'movie',
    region: '中国香港',
    year: 2024,
    genres: ['动作', '犯罪'],
    rating: 7.9,
    views: 1532000,
    publishDate: '2024-07-21',
    duration: '116分钟',
    director: '麦子健',
    cast: ['雷镇东', 'Ada 何', '梁小豪'],
    synopsis:
      '一名深陷债务的摩托车手被迫卷入一场跨城追捕。霓虹闪烁的街头，速度与谎言交织，他渐渐发现真正的猎物竟是自己。一场关于救赎与反抗的追逐就此展开。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20Hong%20Kong%20action%20crime%20film%20poster%20artwork%2C%20a%20determined%20man%20in%20a%20dark%20jacket%20running%20through%20neon-lit%20wet%20city%20streets%20at%20night%2C%20motion%20blur%20and%20rain%2C%20dramatic%20red%20and%20amber%20neon%20reflections%20on%20asphalt%2C%20gritty%20high%20contrast%20lighting%2C%20dynamic%20action%20composition%2C%20professional%20movie%20key%20art%2C%20no%20text%2C%20highly%20detailed&width=600&height=900&seq=gy-movie-03&orientation=portrait',
  },
  {
    id: '1004',
    title: '春潮渐起',
    category: 'movie',
    region: '中国台湾',
    year: 2022,
    genres: ['爱情', '剧情'],
    rating: 8.1,
    views: 742000,
    publishDate: '2022-05-18',
    duration: '104分钟',
    director: '许静姝',
    cast: ['江之远', '叶书瑶'],
    synopsis:
      '海边小镇的旧书店里，两位久别重逢的故人再次相遇。潮水一遍遍涨落，尘封的往事也随之浮起。他们在春潮渐起的季节里，重新学着与过去和解。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20Taiwanese%20romance%20drama%20film%20poster%20artwork%2C%20two%20silhouetted%20figures%20standing%20on%20a%20quiet%20seaside%20boardwalk%20at%20soft%20dusk%2C%20pastel%20pink%20and%20lavender%20sky%20melting%20into%20calm%20ocean%2C%20gentle%20warm%20light%2C%20tender%20emotional%20atmosphere%2C%20professional%20movie%20key%20art%2C%20no%20text%2C%20highly%20detailed&width=600&height=900&seq=gy-movie-04&orientation=portrait',
  },
  {
    id: '1005',
    title: '星尘边境',
    category: 'movie',
    region: '中国大陆',
    year: 2024,
    genres: ['科幻', '剧情'],
    rating: 8.5,
    views: 1675000,
    publishDate: '2024-10-01',
    duration: '135分钟',
    director: '邓雨昆',
    cast: ['顾寒', '程曦', '洛桑'],
    synopsis:
      '在遥远星系的边境站，一名孤独的守望者接收到来自地球的微弱信号。为了验证信号背后的真相，他踏上一段跨越星尘的旅程，也重新认识了作为人的意义。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20science%20fiction%20film%20poster%20artwork%2C%20a%20colossal%20ringed%20planet%20rising%20over%20a%20desolate%20desert%20horizon%20with%20a%20tiny%20astronaut%20silhouette%2C%20deep%20indigo%20and%20amber%20celestial%20glow%2C%20vast%20epic%20scale%2C%20atmospheric%20haze%2C%20futuristic%20mood%2C%20professional%20movie%20key%20art%2C%20no%20text%2C%20highly%20detailed&width=600&height=900&seq=gy-movie-05&orientation=portrait',
  },
  {
    id: '1006',
    title: '老巷烟火',
    category: 'movie',
    region: '中国大陆',
    year: 2021,
    genres: ['家庭', '剧情'],
    rating: 8.8,
    views: 623000,
    publishDate: '2021-12-24',
    duration: '112分钟',
    director: '周立群',
    cast: ['何老太', '孙一鸣', '吴小满'],
    synopsis:
      '老街即将拆改，经营了三十年的小面馆也面临关张。一碗碗热汤面背后，是一家三代人的悲欢与坚守。烟火散尽处，最动人的还是那些平凡而滚烫的日子。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20family%20drama%20film%20poster%20artwork%2C%20a%20warm%20cozy%20old%20residential%20alley%20at%20golden%20evening%20with%20hanging%20red%20lanterns%20and%20steam%20from%20a%20small%20food%20stall%2C%20elderly%20figure%20in%20doorway%2C%20nostalgic%20amber%20lighting%2C%20deeply%20emotional%20small-town%20mood%2C%20professional%20movie%20key%20art%2C%20no%20text%2C%20highly%20detailed&width=600&height=900&seq=gy-movie-06&orientation=portrait',
  },
  {
    id: '2001',
    title: '长安回望录',
    category: 'tv',
    region: '中国大陆',
    year: 2024,
    genres: ['历史', '剧情'],
    rating: 8.9,
    views: 2890000,
    publishDate: '2024-08-15',
    duration: '共 46 集',
    director: '裴长青',
    cast: ['萧景琰', '云清和', '孟砚书'],
    synopsis:
      '盛世长安，暗流涌动。一位出身寒微的史官之女，凭一支笔记录朝堂风云，也在权谋与理想之间守住本心。回望千年前的长安，看见的是人心与时代的交锋。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20ancient%20costume%20historical%20drama%20poster%20artwork%2C%20a%20grand%20Tang%20dynasty%20palace%20city%20under%20twilight%20sky%20with%20intricate%20wooden%20architecture%20and%20burning%20braziers%2C%20a%20robed%20figure%20walking%20a%20long%20stone%20corridor%2C%20dramatic%20warm%20and%20deep%20blue%20contrasts%2C%20epic%20scale%2C%20professional%20key%20art%2C%20no%20text%2C%20highly%20detailed&width=600&height=900&seq=gy-tv-01&orientation=portrait',
    banner:
      'https://readdy.ai/api/search-image?query=Cinematic%20widescreen%20Chinese%20ancient%20costume%20drama%20banner%20artwork%2C%20grand%20twilight%20palace%20city%20with%20glowing%20lanterns%20and%20distant%20mountains%2C%20a%20robed%20figure%20on%20a%20long%20corridor%2C%20warm%20gold%20against%20deep%20blue%20dusk%2C%20epic%20wide%20composition%20with%20space%20for%20text%2C%20no%20text%2C%20highly%20detailed&width=1600&height=900&seq=gy-banner-02&orientation=landscape',
    featured: true,
  },
  {
    id: '2002',
    title: '城市之心',
    category: 'tv',
    region: '中国大陆',
    year: 2023,
    genres: ['爱情', '剧情'],
    rating: 7.8,
    views: 1456000,
    publishDate: '2023-09-08',
    duration: '共 36 集',
    director: '罗以宁',
    cast: ['程嘉树', '黎晚', '秦野'],
    synopsis:
      '高楼林立的都市中，三位年轻人在事业与情感的十字路口各自摸索。当城市的霓虹照亮深夜的窗，他们终于明白，所谓成长就是学会与自己和解。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20urban%20romance%20drama%20poster%20artwork%2C%20a%20young%20professional%20gazing%20at%20a%20glittering%20night%20skyline%20from%20a%20glass%20skyscraper%20office%2C%20warm%20interior%20light%20against%20cool%20city%20lights%2C%20reflective%20mood%2C%20elegant%20modern%20composition%2C%20professional%20key%20art%2C%20no%20text%2C%20highly%20detailed&width=600&height=900&seq=gy-tv-02&orientation=portrait',
  },
  {
    id: '2003',
    title: '迷雾档案',
    category: 'tv',
    region: '中国香港',
    year: 2024,
    genres: ['悬疑', '犯罪'],
    rating: 8.3,
    views: 1780000,
    publishDate: '2024-06-30',
    duration: '共 28 集',
    director: '杜文礼',
    cast: ['方正维', '司徒蓝', '麦一鸣'],
    synopsis:
      '重案组接手一系列看似毫无关联的案件，却在细节中发现惊人的联系。随着调查深入，尘封多年的档案被重新翻开，真相远比想象中更令人不安。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20crime%20mystery%20series%20poster%20artwork%2C%20a%20detective%20in%20a%20long%20coat%20holding%20a%20flashlight%20in%20a%20foggy%20abandoned%20warehouse%2C%20scattered%20papers%20and%20cold%20beams%20of%20light%2C%20moody%20grey-green%20cinematic%20grading%2C%20tense%20mysterious%20atmosphere%2C%20professional%20key%20art%2C%20no%20text%2C%20highly%20detailed&width=600&height=900&seq=gy-tv-03&orientation=portrait',
  },
  {
    id: '2004',
    title: '归途列车',
    category: 'tv',
    region: '中国大陆',
    year: 2022,
    genres: ['家庭', '剧情'],
    rating: 8.2,
    views: 890000,
    publishDate: '2022-03-12',
    duration: '共 32 集',
    director: '侯景明',
    cast: ['老周', '周小满', '林慧'],
    synopsis:
      '一趟开往故乡的绿皮火车上，来自天南海北的旅客各自怀揣心事。列车穿越平原与山川，也载着每个人对家的思念与期盼，驶向心底最柔软的归途。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20family%20drama%20series%20poster%20artwork%2C%20a%20green%20long-distance%20train%20crossing%20vast%20countryside%20at%20golden%20hour%2C%20a%20traveler%20looking%20out%20the%20window%2C%20warm%20nostalgic%20light%2C%20sweeping%20landscape%2C%20emotional%20journey%20mood%2C%20professional%20key%20art%2C%20no%20text%2C%20highly%20detailed&width=600&height=900&seq=gy-tv-04&orientation=portrait',
  },
  {
    id: '2005',
    title: '商海浮沉',
    category: 'tv',
    region: '中国台湾',
    year: 2023,
    genres: ['剧情', '悬疑'],
    rating: 7.7,
    views: 1024000,
    publishDate: '2023-05-20',
    duration: '共 30 集',
    director: '吴承轩',
    cast: ['高铭远', '许安宁', '庄志豪'],
    synopsis:
      '一场突如其来的收购案，让龙头企业陷入前所未有的危机。家族、资本与人情纠缠不清，谁能在商海浮沉中守住最后的底线？一场没有硝烟的战争就此打响。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20business%20drama%20series%20poster%20artwork%2C%20a%20confident%20executive%20standing%20before%20a%20rain-streaked%20boardroom%20window%20overlooking%20a%20city%20at%20dusk%2C%20dramatic%20side%20lighting%2C%20cool%20blue%20and%20warm%20gold%20contrast%2C%20tense%20ambitious%20atmosphere%2C%20professional%20key%20art%2C%20no%20text%2C%20highly%20detailed&width=600&height=900&seq=gy-tv-05&orientation=portrait',
  },
  {
    id: '2006',
    title: '少年游学记',
    category: 'tv',
    region: '中国大陆',
    year: 2024,
    genres: ['青春', '喜剧'],
    rating: 8.0,
    views: 1345000,
    publishDate: '2024-04-02',
    duration: '共 24 集',
    director: '沈知远',
    cast: ['顾一诺', '苏晓', '白杨'],
    synopsis:
      '一群性格迥异的高中生组成研学小队，踏上一次充满欢笑与意外的旅程。在行走的课堂里，他们收获友谊，也悄悄长大。青春最好的样子，就是一起向前走。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20youth%20campus%20drama%20poster%20artwork%2C%20a%20group%20of%20cheerful%20students%20walking%20across%20a%20sunlit%20school%20courtyard%20with%20green%20trees%2C%20bright%20airy%20spring%20light%2C%20warm%20nostalgic%20youthful%20mood%2C%20fresh%20clean%20composition%2C%20professional%20key%20art%2C%20no%20text%2C%20highly%20detailed&width=600&height=900&seq=gy-tv-06&orientation=portrait',
  },
  {
    id: '3001',
    title: '大地脉动',
    category: 'documentary',
    region: '中国大陆',
    year: 2024,
    genres: ['自然'],
    rating: 9.1,
    views: 1120000,
    publishDate: '2024-05-10',
    duration: '共 6 集',
    director: '纪录片中心',
    cast: ['解说：陈述'],
    synopsis:
      '横跨高山、河谷与草原，摄制组历时三年记录下大自然四季流转的壮美画卷。从晨光初照到星河漫天，每一个镜头都在诉说地球沉默而有力的脉搏。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20nature%20documentary%20poster%20artwork%2C%20sweeping%20aerial%20view%20of%20vast%20green%20river%20valleys%20and%20layered%20mountains%20under%20dramatic%20clouds%20at%20sunrise%2C%20golden%20light%20and%20deep%20shadows%2C%20epic%20natural%20grandeur%2C%20professional%20documentary%20key%20art%2C%20no%20text%2C%20highly%20detailed&width=600&height=900&seq=gy-doc-01&orientation=portrait',
    banner:
      'https://readdy.ai/api/search-image?query=Cinematic%20widescreen%20nature%20documentary%20banner%20artwork%2C%20vast%20misty%20mountain%20valleys%20and%20winding%20river%20under%20dramatic%20sunrise%20clouds%2C%20golden%20light%20rays%2C%20sweeping%20aerial%20scale%2C%20atmospheric%20grandeur%20with%20space%20for%20text%2C%20no%20text%2C%20highly%20detailed&width=1600&height=900&seq=gy-banner-03&orientation=landscape',
    featured: true,
  },
  {
    id: '3002',
    title: '匠人匠心',
    category: 'documentary',
    region: '中国大陆',
    year: 2023,
    genres: ['人文'],
    rating: 8.9,
    views: 720000,
    publishDate: '2023-08-22',
    duration: '共 8 集',
    director: '纪实影像组',
    cast: ['解说：林岳'],
    synopsis:
      '走进木作、制瓷、刺绣等传统手艺人的工作间，记录他们数十年如一日的专注与坚持。在快节奏的时代里，仍有人愿意用一生去打磨一件事。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20cultural%20documentary%20poster%20artwork%2C%20close%20view%20of%20an%20artisan%20weathered%20hands%20carving%20delicate%20woodwork%20in%20a%20warm%20sunlit%20old%20workshop%2C%20golden%20dust%20motes%2C%20shallow%20depth%20of%20field%2C%20quiet%20respectful%20mood%2C%20professional%20documentary%20key%20art%2C%20no%20text%2C%20highly%20detailed&width=600&height=900&seq=gy-doc-02&orientation=portrait',
  },
  {
    id: '3003',
    title: '丝路千年',
    category: 'documentary',
    region: '中国大陆',
    year: 2022,
    genres: ['历史', '人文'],
    rating: 8.6,
    views: 540000,
    publishDate: '2022-10-15',
    duration: '共 5 集',
    director: '历史地理摄制组',
    cast: ['解说：孙博'],
    synopsis:
      '沿古丝绸之路西行，从长安到西域，重走那条连接东西方的千年古道。沿途的遗迹、风物与人情，讲述着文明交流互鉴的悠远故事。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20history%20documentary%20poster%20artwork%2C%20sweeping%20sand%20dunes%20of%20the%20ancient%20silk%20road%20at%20sunset%20with%20faint%20caravan%20silhouettes%20and%20a%20lone%20ruined%20watchtower%2C%20warm%20amber%20and%20burnt%20orange%20tones%2C%20vast%20desolate%20grandeur%2C%20professional%20documentary%20key%20art%2C%20no%20text%2C%20highly%20detailed&width=600&height=900&seq=gy-doc-03&orientation=portrait',
  },
  {
    id: '3004',
    title: '深海秘境',
    category: 'documentary',
    region: '中国大陆',
    year: 2024,
    genres: ['自然'],
    rating: 8.8,
    views: 660000,
    publishDate: '2024-02-28',
    duration: '共 4 集',
    director: '海洋探索摄制组',
    cast: ['解说：陈述'],
    synopsis:
      '潜入阳光无法抵达的深海，那里栖息着形态奇异、会发光的生命。摄制组借助深潜器，记录下这片神秘海域从未被人类看清的模样。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20underwater%20nature%20documentary%20poster%20artwork%2C%20glowing%20bioluminescent%20deep%20sea%20creatures%20drifting%20in%20dark%20indigo%20abyss%2C%20ethereal%20blue-green%20light%20beams%2C%20mysterious%20alien%20beauty%2C%20professional%20documentary%20key%20art%2C%20no%20text%2C%20highly%20detailed&width=600&height=900&seq=gy-doc-04&orientation=portrait',
  },
  {
    id: '4001',
    title: '星光舞台',
    category: 'variety',
    region: '中国大陆',
    year: 2024,
    genres: ['喜剧', '青春'],
    rating: 7.9,
    views: 1980000,
    publishDate: '2024-08-01',
    duration: '共 12 期',
    director: '综艺制作团队',
    cast: ['主持：陈曦', '嘉宾：众多歌手'],
    synopsis:
      '一档汇聚实力唱将与新生代歌手的音乐竞演综艺。灯光亮起，掌声雷动，每一期都有令人难忘的舞台瞬间，见证音乐最纯粹的力量。',
    cover:
      'https://readdy.ai/api/search-image?query=Vibrant%20cinematic%20music%20variety%20show%20poster%20artwork%2C%20a%20singer%20silhouette%20on%20a%20grand%20stage%20bathed%20in%20streaming%20spotlights%20and%20confetti%2C%20dynamic%20warm%20amber%20and%20deep%20blue%20stage%20lighting%2C%20energetic%20celebratory%20mood%2C%20professional%20key%20art%2C%20no%20text%2C%20highly%20detailed&width=600&height=900&seq=gy-variety-01&orientation=portrait',
  },
  {
    id: '4002',
    title: '奇妙实验室',
    category: 'variety',
    region: '中国大陆',
    year: 2023,
    genres: ['喜剧', '青春'],
    rating: 8.1,
    views: 1230000,
    publishDate: '2023-07-06',
    duration: '共 16 期',
    director: '科普综艺团队',
    cast: ['主持：顾南风', '嘉宾：众多达人'],
    synopsis:
      '用有趣的方式解读身边的科学现象，把枯燥的原理变成一场场惊喜连连的现场实验。笑着笑着，你就把知识记住了。',
    cover:
      'https://readdy.ai/api/search-image?query=Playful%20cinematic%20science%20variety%20show%20poster%20artwork%2C%20colorful%20glowing%20experiment%20glassware%20and%20floating%20light%20particles%20on%20a%20bright%20modern%20lab%20set%2C%20fun%20cheerful%20bright%20lighting%20with%20warm%20accents%2C%20creative%20energetic%20mood%2C%20professional%20key%20art%2C%20no%20text%2C%20highly%20detailed&width=600&height=900&seq=gy-variety-02&orientation=portrait',
  },
  {
    id: '4003',
    title: '舌尖旅行记',
    category: 'variety',
    region: '中国大陆',
    year: 2024,
    genres: ['人文', '喜剧'],
    rating: 8.4,
    views: 1560000,
    publishDate: '2024-03-18',
    duration: '共 10 期',
    director: '美食综艺团队',
    cast: ['主持：白露', '嘉宾：众多美食家'],
    synopsis:
      '跟着美食的脚步走遍大江南北，寻找藏在街头巷尾的地道风味。一道菜、一个故事、一段人情，用味蕾丈量这片土地的辽阔与温暖。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20food%20travel%20variety%20show%20poster%20artwork%2C%20steaming%20colorful%20regional%20dishes%20on%20a%20rustic%20wooden%20table%20with%20warm%20lantern%20light%2C%20rich%20appetizing%20colors%2C%20cozy%20inviting%20atmosphere%2C%20professional%20key%20art%2C%20no%20text%2C%20highly%20detailed&width=600&height=900&seq=gy-variety-03&orientation=portrait',
  },
];

export const getCategoryName = (slug: string): string =>
  categoryMeta.find((c) => c.slug === slug)?.name ?? slug;

export const getCategoryMeta = (slug: string): CategoryMeta | undefined =>
  categoryMeta.find((c) => c.slug === slug);

export const getResourceById = (id: string): Resource | undefined =>
  resources.find((r) => r.id === id);

export const featuredResources = resources.filter((r) => r.featured);

export const hotResources = [...resources]
  .sort((a, b) => b.views - a.views)
  .slice(0, 6);

export const latestResources = [...resources]
  .sort((a, b) => (a.publishDate < b.publishDate ? 1 : -1))
  .slice(0, 8);